import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import { SnackbarProvider } from 'notistack';

// Contexts
import { AuthProvider } from './contexts/AuthContext';
import { ThemeContextProvider } from './contexts/ThemeContext';
import ProtectedRoute from './components/ProtectedRoute';

// Layouts
import Dashboard from './components/layout/Dashboard';

// Pages
import LoginPage from './pages/LoginPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import HomePage from './pages/HomePage';
import VMListPage from './pages/VMListPage';
import VMDetailPage from './pages/VMDetailPage';
import CreateVMPage from './pages/CreateVMPage';
import GPUManagementPage from './pages/GPUManagementPage';
import OSImagesPage from './pages/OSImagesPage';
import DiskVolumesPage from './pages/DiskVolumesPage';
import SettingsPage from './pages/SettingsPage';
import NotFoundPage from './pages/NotFoundPage';
import ApiTestPage from './pages/ApiTestPage';
import SystemTestPage from './pages/SystemTestPage';
import NetworkManagePage from './pages/NetworkManagePage';
import TerminalPage from './pages/TerminalPage';
import SSHKeyManagePage from './pages/SSHKeyManagePage';
import CloudInitPage from './pages/CloudInitPage';
import ServiceRegistryPage from './pages/ServiceRegistryPage';
import HardwarePresetsPage from './pages/HardwarePresetsPage';
import UserDataTemplatesPage from './pages/UserDataTemplatesPage';
import StorageSettingsPage from './pages/StorageSettingsPage';
import PortForwardingPage from './pages/PortForwardingPage';
import GoldenImagesPage from './pages/GoldenImagesPage';
import MonitoringPage from './pages/MonitoringPage';

function App() {
  return (
    <ThemeContextProvider>
      <AuthProvider>
        <SnackbarProvider maxSnack={3}>
          <Box sx={{ display: 'flex' }}>
          <Routes>
            {/* 로그인 페이지 (인증 불필요) */}
            <Route path="/login" element={<LoginPage />} />
            
            {/* 비밀번호 변경 페이지 (인증 필요하지만 별도 처리) */}
            <Route path="/change-password" element={
              <ProtectedRoute>
                <ChangePasswordPage isForced={true} />
              </ProtectedRoute>
            } />
            
            {/* 보호된 라우트들 */}
            <Route path="/" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }>
              <Route index element={<HomePage />} />
              <Route path="vms" element={<VMListPage />} />
              <Route path="vms/:vmName" element={<VMDetailPage />} />
              <Route path="vms/create" element={<CreateVMPage />} />
              <Route path="terminal" element={<TerminalPage />} />
              <Route path="terminal/:vmName" element={<TerminalPage />} />
              <Route path="networks" element={<NetworkManagePage />} />
              <Route path="service-registry" element={<ServiceRegistryPage />} />
              <Route path="gpus" element={<GPUManagementPage />} />
              <Route path="os-images" element={<OSImagesPage />} />
              <Route path="golden-images" element={<GoldenImagesPage />} />
              <Route path="volumes" element={<DiskVolumesPage />} />
              <Route path="ssh-keys" element={<SSHKeyManagePage />} />
              <Route path="cloud-init" element={<CloudInitPage />} />
              <Route path="hardware-presets" element={<HardwarePresetsPage />} />
              <Route path="userdata-templates" element={<UserDataTemplatesPage />} />
              <Route path="port-forwarding" element={<PortForwardingPage />} />
              <Route path="monitoring" element={<MonitoringPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="settings/storage" element={<StorageSettingsPage />} />
              <Route path="settings/change-password" element={<ChangePasswordPage isForced={false} />} />
              <Route path="system-test" element={<SystemTestPage />} />
              <Route path="api-test" element={<ApiTestPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
          </Box>
        </SnackbarProvider>
      </AuthProvider>
    </ThemeContextProvider>
  );
}

export default App; 